import { getLotLabel } from './get-lot-label';

import type { IGetLocalization, ILot } from 'src/interfaces';

export const getLot = (lot: ILot, getLocalization: IGetLocalization) =>
  `${getLocalization(getLotLabel(lot))} ${lot.number}`;
